import { type TrendEvent } from '../../api/client';
import { JsonField } from './JsonField';
import { MetricsTable } from './MetricsTable';
import { ProductDetailsCard } from './ProductDetailsCard';

function DriverPill({ driver }: { driver: string }) {
  return <span className="pill-neutral mono">{driver}</span>;
}

export function TrendEventModal({
  event,
  onClose,
}: {
  event: TrendEvent;
  onClose: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="flex max-h-[90vh] w-full max-w-6xl flex-col gap-4 overflow-auto rounded-lg border border-border-default bg-panel p-6"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3">
          <ProductDetailsCard event={event} />
          <button type="button" className="btn-ghost btn-sm shrink-0" onClick={onClose}>
            Закрыть
          </button>
        </div>

        <MetricsTable event={event} />

        <section>
          <div className="rubric mb-2">Драйверы</div>
          <div className="flex flex-wrap gap-1">
            {(event.llm_drivers ?? []).map((driver) => (
              <DriverPill key={driver} driver={driver} />
            ))}
            {(event.llm_drivers ?? []).length === 0 ? (
              <span className="text-text-tertiary">—</span>
            ) : null}
          </div>
        </section>

        {event.llm_text ? (
          <section className="card card-padding">
            <div className="rubric">AI-комментарий</div>
            <p className="whitespace-pre-wrap text-body text-text-secondary">{event.llm_text}</p>
          </section>
        ) : null}

        <JsonField title="Signals JSON" value={event.signals} />
        <JsonField title="Характеристики карточки" value={event.product_details?.product_props} />
        <JsonField title="Данные магазина" value={event.product_details?.shop_info} />
        <JsonField title="Цена и наличие" value={event.product_details?.price_info} />
        <JsonField title="Сырые данные карточки" value={event.product_details?.raw_attributes} />
      </div>
    </div>
  );
}
